"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _colors = require("../../../constants/colors");
var _focusRing = require("../../../util/focusRing");
var _withFocusClassName = require("../../../util/withFocusClassName");
const styles = {
  error: {
    backgroundColor: _colors.buttonDestructive,
    fontColor: _colors.neutralLight40
  },
  info: {
    backgroundColor: _colors.infoLight10,
    fontColor: _colors.neutralDark40
  },
  success: {
    backgroundColor: _colors.success,
    fontColor: _colors.neutralDark40
  },
  warning: {
    backgroundColor: _colors.warning,
    fontColor: _colors.neutralDark40
  }
};
const getColor = _ref => {
  let {
    type
  } = _ref;
  return styles[type].fontColor;
};
const getBackgroundColor = _ref2 => {
  let {
    type
  } = _ref2;
  return styles[type].backgroundColor;
};
const focusRing = (0, _focusRing.getFocusRingStyles)({
  includeFocusPseudoClass: true,
  colorOverride: _colors.neutralDark40,
  offset: 4,
  radius: 4,
  theme: "light"
});
const ToastStyled = (0, _withFocusClassName.withFocusToggleClassName)((0, _styled.default)("div")`
    min-height: 48px;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;

    color: ${getColor};
    background-color: ${getBackgroundColor};

    font-weight: 500;
    font-size: 14px;

    ${focusRing}
`);
exports.ToastStyled = ToastStyled;
ToastStyled.displayName = "ToastStyled";
//# sourceMappingURL=ToastStyled.js.map